var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-bar",style:({ width: `${_vm.width}px` })},[_c('div',{staticClass:"progress-bar__text"},[_vm._t("default"),_vm._m(0)],2),_c('div',{staticClass:"progress",style:(_vm.progressStyle)})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"dots"},[_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }